module.exports = __webpack_public_path__ + "static/read-docs-macbook-aef753abe384f54d9a871e7f3b4758df.png";